import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-training-bulk-update-modal',
  templateUrl: './training-bulk-update-modal.component.html',
  styleUrls: ['./training-bulk-update-modal.component.css']
})
export class TrainingBulkUpdateModalComponent implements OnInit {
  @Input() employeeData: any;
  @Input() trainData: any;

  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmClicked() {
    this.activeModal.close();
  }

  closeClicked() {
    this.activeModal.dismiss();
  }

}